import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-ancestral-cream py-16 md:py-24 text-ancestral-dark" data-id="element-170">
      <div className="container mx-auto px-4" data-id="element-171">
        <div className="max-w-3xl mx-auto text-center" data-id="element-172">
          <FadeIn data-id="element-173">
            <ShieldCheckIcon className="w-20 h-20 text-ancestral-green mx-auto mb-6" data-id="element-174" />
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-ancestral-green mb-8" data-id="element-175">
              GARANTÍA TOTAL DE 60 DÍAS
            </h2>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-176">
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-ancestral-gold/30" data-id="element-177">
              <p className="text-xl md:text-2xl font-medium leading-relaxed text-ancestral-dark/90" data-id="element-178">
                Si no ves resultados reales en 60 días, te devolvemos cada
                centavo. Sin preguntas. Sin complicaciones.{' '}
                <strong className="text-ancestral-green font-bold" data-id="element-179">
                  Cero riesgo.
                </strong>
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}